export const RequestForReconsideration_uischema = {
  name: "Request for Reconsideration",
  pageInfo: {
    text: "Use this form to upload documents to your submitted application. Uploaded documents will be added to case documents. Please check the correspondence issued for details on what is required for your case.",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          machine_name: "fileType",
          value: "Request for Reconsideration",
          widget: "text",
          style: {
            display: "none",
          },
        },
        {
          machine_name: "files",
          widget: "file_upload",
          file_upload: { fileType: "Request for Reconsideration" },
          accept_multiple: true,
          required: true,
          validate: ["required", "file_required"],
          checkFilesAdded: true,
          documentAuth: "dh",
        },
        {
          machine_name: "document_description",
          widget: "text",
          label: "Document Description",
          validate: ["required"],
          maxLength: 100,
        },
      ],
    },
  ],
};
